export default "__VITE_ASSET__DO37UZV6__"